import { createAction, props } from '@ngrx/store';
import { Detection } from '../../models/detection';
import { EmergencyTemplate } from '../../models/emergency-template';
import { Update } from '@ngrx/entity';
import { Comment } from '../../models/comment';
import { DetectionFilters } from '../../tools/detection.tools';
import { Attachment } from '../../models/attachment';
import { SiteDetectionLabel } from '../../models/site-detection-label';

export const setDetectionFilters = createAction('[Detection] Set Filters', props<{ filters: any}>());
export const initDetectionFilters = createAction('[Detection] Init Filters', props<{ filters: DetectionFilters }>());
export const updateDetectionFilters = createAction('[Detection] Update Filters', props<{ patch: Partial<DetectionFilters> }>());

export const loadDetections = createAction('[Detection] Load All', props<{  organizationId: string, siteId: string }>());
export const loadDetectionsSuccess = createAction('[Detection] Load success', props<{ detections: Detection[] }>());
export const loadDetectionsFailure = createAction('[Detection] Load failure', props<{ error: any }>());

export const clearAllDetections = createAction('[Detection] Clear All');
export const selectDetection = createAction('[Detection] Select', props<{ id: string | undefined}>());

export const loadDetectionEmergencyTemplate = createAction('[Detection] Load Emergency Template ', props<{  organizationId: string, siteId: string }>());
export const loadDetectionEmergencyTemplateSuccess = createAction('[Detection] Load Emergency Template success', props<{ template: EmergencyTemplate }>());
export const loadDetectionEmergencyTemplateFailure = createAction('[Detection] Load Emergency Template failure', props<{ error: any }>());
export const clearDetectionEmergencyTemplate = createAction('[Detection] Clear Emergency Template');

export const addDetectionEmergency = createAction('[Detection] Add Detection Emergency ', props<{ organizationId: string, siteId: string, detectionId: string, payload: any }>());
export const addDetectionEmergencySuccess = createAction('[Detection] Add Detection Emergency success', props<{ update: Update<any> }>());
export const addDetectionEmergencyFailure = createAction('[Detection] Add Detection Emergency failure', props<{ error: any }>());

export const updateDetection = createAction('[Detection] Update Detection ', props<{ organizationId: string, siteId: string, detectionId: string, payload: any }>());
export const updateDetectionSuccess = createAction('[Detection] Update Detection success', props<{ update: Update<any> }>());
export const updateDetectionFailure = createAction('[Detection] Update Detection failure', props<{ error: any }>());

export const deleteDetection = createAction('[Detection] Delete Detection', props<{ organizationId: string, siteId: string, detectionId: string, payload: any }>());
export const deleteDetectionSuccess = createAction('[Detection] Delete Detection success', props<{ id: string }>());
export const deleteDetectionFailure = createAction('[Detection] Delete Detection failure', props<{ error: any }>());

export const addDetection = createAction('[Detection] Add Detection', props<{ organizationId: string, siteId: string, payload: any }>());
export const addDetectionSuccess = createAction('[Detection] Add Detection success', props<{ detection: Detection }>());
export const addDetectionFailure = createAction('[Detection] Add Detection failure', props<{ error: any }>());

export const loadSiteDetectionLabels = createAction('[Detection] Load Site Detection Labels ', props<{  organizationId: string, siteId: string }>());
export const loadSiteDetectionLabelsSuccess = createAction('[Detection] Load Site Detection Labels success', props<{ labels: SiteDetectionLabel[] }>());
export const loadSiteDetectionLabelsFailure = createAction('[Detection] Load Site Detection Labels failure', props<{ error: any }>());
export const clearSiteDetectionLabels = createAction('[Detection] Clear Site Detection Labels');

export const loadDetectionComments = createAction('[Detection] Load Detection Comments ', props<{ organizationId: string, siteId: string, detectionId: string  }>());
export const loadDetectionCommentsSuccess = createAction('[Detection] Load Detection Comments success', props<{ comments: Array<Comment> }>());
export const loadDetectionCommentsFailure = createAction('[Detection] Load Detection Comments failure', props<{ error: any }>());

export const addDetectionComment = createAction('[Detection] Add Detection Comment ', props<{ organizationId: string, siteId: string, detectionId: string, payload: any }>());
export const addDetectionCommentSuccess = createAction('[Detection] Add Detection Comment success', props<{ comment: Comment }>());
export const addDetectionCommentFailure = createAction('[Detection] Add Detection Comment failure', props<{ error: any }>());

export const generateDetectionsReport = createAction('[Detection] Generate Detections Report ', props<{ organizationId: string, siteId: string, formats: Array<string>, ids: Array<string>}>());
export const generateDetectionsReportSuccess = createAction('[Detection] Generate Detections Report success', props<{ email: string }>());
export const generateDetectionsReportFailure = createAction('[Detection] Generate Detections Report failure', props<{ error: any }>());

export const loadDetectionSummary = createAction('[Detection] Load Detection Summary ', props<{ organizationId: string, siteId: string }>());
export const loadDetectionSummarySuccess = createAction('[Detection] Load Detection Summary success', props<{ summary: any }>());
export const loadDetectionSummaryFailure = createAction('[Detection] Load Detection Summary failure', props<{ error: any }>());
export const clearDetectionSummary = createAction('[Detection] Clear Detection Summary');

export const setDetectionShow = createAction('[Detection] Set Detection Show property', props<{ id: string, show: boolean}>());
export const setDetectionsShow = createAction('[Detection] Set Detections Show property', props<{ ids: Array<string>, show: boolean }>());

export const loadDetectionReferenceAttachments = createAction('[Detection] Load Detection Reference Attachments', props<{ organizationId: string, siteId: string, detectionId: string, referenceBatchId: string }>());
export const loadDetectionReferenceAttachmentsSuccess = createAction('[Detection] Load Detection Reference Attachments success', props<{ attachments: Array<Attachment> }>());
export const loadDetectionReferenceAttachmentsFailure = createAction('[Detection] Load Detection Reference Attachments failure', props<{ error: any }>());

export const setDetectionFavoriteAttachment = createAction(
  '[Detection] Set Favorite Attachment',
  props<{
    organizationId: string;
    siteId: string;
    detectionId: string;
    filename: string;
  }>()
);

export const setDetectionFavoriteAttachmentSuccess = createAction(
  '[Detection] Set Favorite Attachment success',
  props<{ update: Update<Detection> }>()
);

export const setDetectionFavoriteAttachmentFailure = createAction(
  '[Detection] Set Favorite Attachment failure',
  props<{ error: any }>()
);
